import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../firebase/AuthContext';
import GoogleSignInButton from './GoogleSignInButton';
import educadoLogo from '../images/educado_logo.png';
import { HiMenu, HiX } from 'react-icons/hi';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const navbarHeight = 64; // h-16 = 64px
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navbarHeight;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const navbarHeight = 64; // h-16 = 64px
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - navbarHeight;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
    setMobileMenuOpen(false);
  };

  const handleNavigation = (link) => {
    if (link.route) {
      navigate(link.route);
      setMobileMenuOpen(false);
    } else {
      scrollToSection(link.id);
    }
  };

  // Dynamically set nav links based on user login
  const navLinks = [
    { id: 'home', label: 'Home' },
    user
      ? { id: 'journey', label: 'Your AI Journey' }
      : { id: 'progress', label: 'Progress' },
    { id: 'stats', label: 'Stats' },
    { route: '/polling', label: 'Polling Zone' },
    { id: 'how', label: 'How' },
    { id: 'about', label: 'About' },
  ];

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2.5 hover:opacity-80 transition-opacity"
          >
            <img src={educadoLogo} alt="Educado AI" className="h-8 w-8" />
            <span className="text-xl font-bold text-gray-900">Educado AI</span>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <button
                key={link.id || link.route}
                onClick={() => handleNavigation(link)}
                className="font-medium text-gray-700 hover:text-primary transition-colors"
              >
                {link.label}
              </button>
            ))}
            <GoogleSignInButton variant="header" />
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-primary transition-colors"
          >
            {mobileMenuOpen ? (
              <HiX className="text-2xl" />
            ) : (
              <HiMenu className="text-2xl" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200 space-y-2">
            {navLinks.map((link) => (
              <button
                key={link.id || link.route}
                onClick={() => handleNavigation(link)}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
              >
                {link.label}
              </button>
            ))}
            <div className="px-4 pt-2">
              <GoogleSignInButton variant="header" />
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
